import { useRef, useEffect, useState,useCallback} from 'react';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { setDrawFeature, 
        setMapCentreCord,
        setStartCord
       } from '../../redux/actions/mapaction';
import UseWindowDimensions from '../screensizecontainer/windowdimensions';
import './mapcontainer.css'
import { useDispatch, useSelector } from "react-redux";
import mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { VillageRevPolyLayer } from './Container';
import { addStartPointlayer, addEndPointlayer, Routelayer} from './Container/NavigationLayer';
import {get_polygon_centroid} from './Container/polyCentroid'
import {updaterGlobalRaster,handleRoiChaangeGlobal} from './Container/Rasterlayer/SelectedRaster'
import {updateViewPort} from './Container/updateViewPort'
import {raster_url, rater_layer_label} from '../FormComopents/Form/Const'
import {adminBoundry,Labels} from './Container/VectorLayer'
import VectorLayerVisibilty from './Container/VectorLayer/LayerVisibility'
import { mapStyleLlist } from '../FormComopents/Form/Const';
import { GetRouteApi } from '../api_servcies/GetRouteApi';
// import { FisheryJson } from '../api_servcies/FisheryJson';

import PitchToggle from './components/PitchToggle';
import { UpdatePolyRaster, handleNoneLayerRoi } from './Container/Rasterlayer/Polyraster';
import {Waterbody, handleWaterbodylayer} from './Container/VectorLayer/Waterbody'
import {Userproject} from './Container/VectorLayer/UserProject'
import {useResize} from "./Container/useResize"
import { MapTerrain } from './Container/Rasterlayer/MapTerrain';
// import { AddElevatiocnMap } from './Container/Rasterlayer/Elevation';
// function updateMapstyle(map,mapstyle){
//     const stylename = mapStyleLlist[mapstyle]
//     if(map){
//         map.setStyle('mapbox://styles/mapbox/' + stylename);
//     }

// }



const Map = (props) => {
// console.log(mapStyleLlist)
const { pitch, bearing , marginright, accessToken} = props
const mapstyle = useSelector(state => state.mapreducer.mapstyle)
// useEffect(()=> {
//     if(map && mapstyle)
//     updateMapstyle(map,mapstyle)
// },[mapstyle])

const stylename = mapStyleLlist[mapstyle]
const dispatch = useDispatch()
const { height, width } = UseWindowDimensions();
const marginleft = useSelector((state) => 
state.controlbutton.mapconatiner_margin_left
);
let centrecord = useSelector(state => state.mapreducer.mapcentrecord)
let revpolygeojaon = useSelector(state => state.mapreducer.villagerevpoly)
let activevectorlayer =  useSelector(state => state.mapreducer.vectorlayer)
let activeglobalraster =  useSelector(state => state.mapreducer.globalraster)
let activerasterroi =  useSelector(state => state.mapreducer.rasterroi)

let startcord = useSelector(state=> state.mapreducer.startcord)
const routecord = useSelector(state => state.mapreducer.navroutedata.route)
// const rasterlayerdate= ['2022-10-01', '2022-11-01']
const rasterlayerdate = useSelector(state => state.mapreducer.ratserdate)
let selectedfeaturecords = useSelector(state=> state.mapreducer.selectedfeature.coords)
// let fish_json = FisheryJson().geojson
// console.log(revpolygeojaon)
// console.log(fish_json)
const activerasterparam = () => {
    let RasterArray = []
    let RasterId
    let url 
    if (activeglobalraster !== undefined && activeglobalraster !=='None')
    {
        var newArray = rater_layer_label.filter(function(item)
        {
        return (item.label === activeglobalraster);
        });
        RasterArray = newArray
        if(RasterArray!==undefined && RasterArray.length){
            RasterId =  RasterArray[0].value
            url = raster_url[RasterId]
        } 
        
    }
    return {RasterId, url}
}
const base_url = activerasterparam().url
const rasterlayer = activerasterparam().RasterId
const opacity = 0.9
const mapContainerRef = useRef(null);
const [map, setMap] = useState(null)
const onResize = useCallback(() => {
    if (map) {
        map.resize();
    }
    }, [map]);
useResize(onResize);

const  viewportlnglat = () => {
    let longitude = 75
    let latitude = 22
    if(centrecord!==undefined && centrecord.longitude, centrecord.latitude){
        longitude= centrecord.longitude
        latitude = centrecord.latitude

    }
    return {longitude,latitude}
}
const [viewport, setViewport] = useState({

    longitude:viewportlnglat().longitude,
    latitude:viewportlnglat().latitude
});

const [end, setEnd] = useState(
    [centrecord.longitude,centrecord.latitude]
)
useEffect(()=> {
    setEnd([centrecord.longitude,centrecord.latitude])
},[centrecord])
const start = [startcord.longitude, startcord.latitude]
const routedata= GetRouteApi().route
// const fishery_data = FisheryJson()
// console.log(fishery_data)

useEffect(() => {
    navigator.geolocation.getCurrentPosition((pos) => {
      setViewport({
        ...viewport,
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
        zoom: 3.5,
      });
      dispatch(setStartCord({
        latitude:  pos.coords.latitude,
        longitude: pos.coords.longitude,

      }))

    });
    setMap(map)

  }, [])
  
    useEffect(() => {
        mapboxgl.accessToken = accessToken;
        const map = new mapboxgl.Map({
            container: mapContainerRef.current,
            zoom: 14,
            center: [viewport.longitude, viewport.latitude],
            pitch: pitch,
            bearing: bearing,
            // style: `mapbox://styles/mapbox/satellite-v9`,
            style: `mapbox://styles/mapbox/${stylename}`,
            
        });
      
        // [westLongitude, northLatitude],
        // [eastLongitude, northLatitude],
        // [eastLongitude, southLatitude],
        // [westLongitude, southLatitude]
        const draw = new MapboxDraw({
            userProperties: true,
            displayControlsDefault: false,
            controls: {
                polygon: true,
                line_string: false,
                point:false,
                trash: true
            },

            });
        // map.on('draw.update', dispatch(openAnalysisWindow));
        const navcontrol = new mapboxgl.NavigationControl()
        map.addControl(navcontrol, 'bottom-right');
        map.addControl(draw, 'bottom-right');
        map.addControl(new PitchToggle({ minpitchzoom: 16 }), "bottom-right");
        const setSelectedFeature = function(e) {
            if (e.features.length && e.features[0].type === 'Feature') {
                let points = []
                e.features[0].geometry.coordinates[0].forEach(element => {
                    let _var = {x: element[0], y: element[1]}
                    points.push(_var)
                    
                });
                dispatch(setDrawFeature({id: e.features[0].id,
                    coords: e.features[0].geometry.coordinates
                }))
                dispatch(setMapCentreCord({
                    longitude:get_polygon_centroid(points).x,
                    latitude:get_polygon_centroid(points).y

                }))
            }
        }
        map.on('draw.selectionchange', setSelectedFeature);
        map.on('load', async() => {
        
        
            var bounds = map.getBounds();
            var zoom = map.getZoom();
            // console.log(bounds,zoom)
        // console.log(_bbox)
        map.addSource('mapbox-dem', {
            'type': 'raster-dem',
            'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
            'tileSize': 512
            });
        map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1.5 });
        map.addLayer({
            'id': 'sky',
            'type': 'sky',
            'paint': {  
            'sky-type': 'atmosphere',
            'sky-atmosphere-sun': [0.0, 90.0],
            'sky-atmosphere-sun-intensity': 15
            }
            });
           
        // const elevation = Math.floor(
        //     // Do not use terrain exaggeration to get actual meter values
        //     map.queryTerrainElevation(lngLat, { exaggerated: false })
        //     );
        // console.log(elevation)
        // ContourLayer(map)
        VillageRevPolyLayer(map,revpolygeojaon)
        adminBoundry(map)
        // Waterbody(map,
        //     activevectorlayer.WaterBodies,
        //     0.5)
        Labels(map)
        Userproject(map)
        // ClusterLayer(map,fish_json)
        Routelayer(map,routecord)
        setMap(map)
        addStartPointlayer(map,start)
        addEndPointlayer(map,end)        
        });

            }, 
            [pitch, bearing
                ,marginright
                // ,viewport
                ,stylename
            ])

       
        // console.log(map.getStyle())

        // useEffect(()=> {
        //     if(map)
        //     {AddElevationMap(map)}
        // },[map])
        useEffect(()=> {
            if(map )
                {  
                VectorLayerVisibilty(map, activevectorlayer)
            }
            },[activevectorlayer,map])

        useEffect(()=> {
            if(map && revpolygeojaon && revpolygeojaon.geometry )
            {VillageRevPolyLayer(map,revpolygeojaon)}
        },[map,revpolygeojaon])
        
        const updateRevpoly = () => {
            if(map && revpolygeojaon && map.getLayer('revenuepoly_layer'))
            { map.getSource('revenuepoly_layer').setData(revpolygeojaon)}
        } 
        useEffect(() => {
            if(map && revpolygeojaon )
                { updateRevpoly();}
             }, [revpolygeojaon]);
      

        useEffect(() => {
            updateViewPort(map,centrecord)
            }, [centrecord]);
            
        useEffect(()=>{
            if(map &&  end)
            {addEndPointlayer(map,end)}
            },[end])

        useEffect(()=>{
            if(map &&  start)
            {addStartPointlayer(map,start)}
             },[start])

        useEffect(()=> {
            if(map && routecord)
            Routelayer(map,routecord)
        },[routecord])



        useEffect(()=> {
            
            if(map && rasterlayer && rasterlayerdate && base_url && activerasterroi==='Global')
                {   
                    updaterGlobalRaster(map, rasterlayer, 
                    rasterlayerdate, base_url, opacity)
                }
        },[activeglobalraster,activerasterparam().RasterId,rasterlayerdate])
        // if(activeglobalraster === None)
        // useEffect(()=> {
        //     if(activeglobalraster && activeglobalraster ==='None' && activerasterroi==='Global')
        //     handleNoneLayer(map,rasterlayer)
        // },[activeglobalraster,map,activerasterroi])

        useEffect(()=> {
            if(activeglobalraster && activerasterroi !=='' )
            handleRoiChaangeGlobal(map,activerasterroi)
        },[activerasterroi,map])

        // handleRoiChaangeGlobal(map,rasterroi)


        useEffect(()=> {
            if(activeglobalraster && activeglobalraster ==='None')
            handleNoneLayerRoi(map,activeglobalraster)
        },[activeglobalraster,map])

       


        useEffect(()=> {
            if(map && rasterlayer && rasterlayerdate && base_url 
                && selectedfeaturecords!==undefined 
                && selectedfeaturecords.length>0 
                && activerasterroi==='UserROI')
            {
                UpdatePolyRaster (map, 
                    rasterlayer, 
                    rasterlayerdate, 
                    base_url, 
                    opacity, 
                    selectedfeaturecords)
            }
        },[activeglobalraster,activerasterparam().RasterId,rasterlayerdate,activerasterroi,selectedfeaturecords])


        useEffect(()=> {
            MapTerrain (map,pitch)
        },[pitch])

        useEffect(()=> {
            if(map && activevectorlayer.WaterBodies===false)
            handleWaterbodylayer(map,activevectorlayer.WaterBodies)
        },[activevectorlayer.WaterBodies])
        
        useEffect(()=> {
            if(map && activevectorlayer.WaterBodies!==undefined)
            {
                Waterbody(map,
                    activevectorlayer.WaterBodies,
                    opacity)
            }
        },[activevectorlayer.WaterBodies])


        // useEffect(()=> {
        //     if(map && activevectorlayer.WaterBodies===false)
        //     handleUserprojectlayer(map,activevectorlayer.Userproject)
        // },[activevectorlayer.Userproject])
        
        // useEffect(()=> {
        //     if(map && activevectorlayer.Userproject!==undefined)
        //     {
        //         Userproject(map,
        //             activevectorlayer.Userproject,
        //             opacity)
        //     }
        // },[activevectorlayer.Userproject])



        // useEffect(()=> {
            
        //     if(map && rasterlayer && rasterlayerdate && base_url)
        //         {   
        //             updaterGlobalRaster(map, rasterlayer, 
        //             rasterlayerdate, base_url, opacity)
        //         }
        // },[activeglobalraster,activerasterparam().RasterId,rasterlayerdate])


        // activerasterroi
        // handleNoneLayer(map,activeglobalraster)
        // console.log(map.getStyle())

        return (

            <div className='mapcontainer'  ref={mapContainerRef}  style={{
                position:'relative',
                marginLeft: marginleft, 
                marginRight: marginright,
                height: height, width:width
            }}
            />
    )

}
export default Map








